export default __webpack_public_path__ + "static/media/img_tow.98f63acb.svg";